import React, { useState } from "react";
// import { useTranslation } from "react-i18next";
import { useTranslation } from "react-i18next";

import ClearIcon from "@mui/icons-material/Clear";
import parse from "html-react-parser";
import { ResponsiveBox, Grid, IconButton, Tooltip, Typography } from "../../primitives";

const ConfirmationMessage = (props) => {
  const { t } = useTranslation();
  const {
    message,
    setShowMessage,
    inputRef,
    handleClose: handleCloseV2,
    ariaText,
  } = props;
  const handleClose = () => {
    if (setShowMessage) {
      setShowMessage(false);
    }
    if (handleCloseV2) {
      handleCloseV2();
    }
  };
  const labelToShow = ariaText || t("erps.confirmation.message.close.icon");
  return (
    <ResponsiveBox
      display={"flex"}
      justifyContent="space-between"
      alignContent={"center"}
      alignItems="center"
      className="confirmation__message"
    >
      <ResponsiveBox ref={inputRef}>
        <Typography
          variant="label"
          className="app_confirmation_success_message" style={{whiteSpace: "pre-wrap"}}
        >
          {parse(message)}
        </Typography>
      </ResponsiveBox>
      <Tooltip title={labelToShow}>
        <IconButton aria-label={labelToShow} onClick={handleClose}>
          <ClearIcon className="confirmation__message__close__icon" />
        </IconButton>
      </Tooltip>
    </ResponsiveBox>
  );
};

export default ConfirmationMessage;
